import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { HardHat, Mail, ArrowLeft, CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post("/auth/forgot-password", { email, origin_url: window.location.origin }); }
    catch { /* generic response either way */ }
    setSent(true); setBusy(false);
  };

  return (
    <div className="min-h-screen bg-emerald-950 flex items-center justify-center p-4" data-testid="forgot-password-page">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2 mb-6 text-white">
          <div className="h-9 w-9 rounded-lg bg-lime-400/20 flex items-center justify-center"><HardHat className="h-5 w-5 text-lime-300" strokeWidth={2.2} /></div>
          <span className="font-heading font-bold text-lg tracking-tight">BidMatchAI</span>
        </Link>
        <div className="bg-white rounded-3xl shadow-2xl p-8">
          {sent ? (
            <div className="text-center py-4" data-testid="forgot-sent">
              <CheckCircle2 className="h-12 w-12 text-emerald-600 mx-auto mb-4" />
              <h1 className="font-heading text-2xl font-bold text-slate-900">Check your email</h1>
              <p className="text-slate-500 mt-2 text-sm">If an account exists for <b>{email}</b>, we've sent a password reset link. It expires in 1 hour.</p>
              <Link to="/login" className="inline-flex items-center gap-1.5 mt-6 text-sm text-emerald-700 hover:text-emerald-800"><ArrowLeft className="h-4 w-4" /> Back to sign in</Link>
            </div>
          ) : (
            <>
              <h1 className="font-heading text-2xl font-bold text-slate-900">Forgot your password?</h1>
              <p className="text-slate-500 mt-1 text-sm">Enter your email and we'll send you a link to reset it.</p>
              <form onSubmit={submit} className="mt-6 space-y-4">
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
                  <input value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" type="email" required placeholder="you@company.com"
                    className="w-full rounded-xl border border-slate-200 pl-10 pr-4 py-3 text-sm focus:outline-none focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/30" />
                </div>
                <button type="submit" disabled={busy} data-testid="forgot-submit"
                  className="w-full bg-emerald-900 text-white rounded-xl py-3.5 text-sm font-semibold hover:bg-emerald-800 disabled:opacity-60 transition-colors">
                  {busy ? "Sending…" : "Send reset link"}
                </button>
              </form>
              <Link to="/login" className="inline-flex items-center gap-1.5 mt-5 text-sm text-slate-500 hover:text-slate-700"><ArrowLeft className="h-4 w-4" /> Back to sign in</Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
